import configAxios from "./axiosConfig";

export const get = async ({ path, token }) => {
  const response = await configAxios.get(path, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
